import React, { useContext, useEffect, useState } from "react";
import { UseSalesContractWeb3 } from "../ConnectivityAss/hooks";
import { AppContext } from "../utils";
import { Contract, ethers } from "ethers";
import createdPresaleAbi from "../utils/createdPresaleAbi.json";
import { formatUnits } from "@ethersproject/units";

let walletAddress = "0x8ba1f109551bD432803012645Ac136ddd64DBA72";

const provider = new ethers.providers.JsonRpcProvider(
  "https://data-seed-prebsc-1-s1.binance.org:8545/"
);

const VoidSigner = new ethers.VoidSigner(walletAddress, provider);
function handleClick(event) {
  event.preventDefault();
}
export default function TotalAmountRaised() {
  const salesContract = UseSalesContractWeb3();
  const [totalAmount, settotalAmount] = useState(0);
  useEffect(async () => {
    if (salesContract) {
      try {
        const count = await salesContract.methods.getAllPreSalesLength().call();
        let totalAmount = 0;
        for (let index = 0; index <= count; index++) {
          const address = await salesContract.methods.allPreSales(index).call();
          const contract = new Contract(address, createdPresaleAbi, VoidSigner);
          const amount = await contract.amountRaised();
          totalAmount += +amount;
        }
        settotalAmount((+formatUnits(totalAmount.toString())).toFixed(3));
      } catch (error) {
        console.log(error);
      }
    }
  }, [salesContract]);

  return <>{totalAmount}</>;
}
